import { useCallback } from 'react';
import { useLinkTo } from '@react-navigation/native';

export const useTeamPress = (organisationUuid: string) => {
	const link = useLinkTo();

	const handleTeamPress = useCallback(
		(uuid: string) => () => {
			link(`/organizations/${organisationUuid}/teams/${uuid}`);
		},
		[link, organisationUuid],
	);

	return handleTeamPress;
};
